<div class="columns small-12 medium-6" data-masonry-item="">
  <div class="panel rs-bg-grey1 clearfix" *ngIf="isPendingProductDetails">
    <div class="small-only-text-center">
      <div
        class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
      ></div>
    </div>

    <div class="panel rs-bg-grey3">
      <div class="rs-flex-row rs-flex-middle rs-flex-dir-col-small-only">
        <div class="rs-flex-column rs-flex-shrink">
          <div
            class="panel rs-inline-block rs-wd-s5 rs-wd-m6 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
        <div class="rs-flex-column">
          <div
            class="panel rs-inline-block rs-wd-s14 rs-wd-m18 rs-h-s5 rs-h-m2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="panel rs-bg-grey1 clearfix"
    *ngIf="
      selectedProduct?.mobileProductDetails?.activeSubscription?.family !== 'Epic' && activeFavApp
    "
  >
    <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
      {{ 'mobile.favapp.title' | translate }}
    </h3>
    <div class="panel rs-bg-grey3 clearfix" aria-live="polite">
      <px-alert [alertKey]="'changeFavappAlert'"></px-alert>
      <div id="jsrs-display-favapp" [hidden]="editFavApp">
        <div class="rs-flex-row rs-flex-middle rs-flex-dir-col-small-only">
          <div class="rs-flex-column rs-flex-shrink">
            <p>
              <img
                class="rs-maxh-s5 rs-no-margin"
                alt="{{ activeFavApp.name }}"
                [src]="activeFavApp.iconLocation"
              />
            </p>
          </div>
          <div class="rs-flex-column">
            <p *ngIf="!isPendingInCart && !showPendingOrder">
              <button
                class="rs-link-action rs-link-action-edit jsrs-modify-favapp"
                (click)="toggleEditor()"
                data-tms-event="button-click"
                attr.data-tms-button-zone="{{ 'mobile.favapp.title' | translate }}"
                attr.data-tms-button-name="{{ 'mobile.favapp.change' | translate }}"
                data-cy="changeFavAppButton"
              >
                <span class="rs-link-action-label" aria-hidden="true">{{
                  'mobile.favapp.change' | translate
                }}</span
                ><span class="rs-action-link-icon" title="Change your Fav-App"
                  ><span class="show-for-sr">{{ 'mobile.favapp.change' | translate }}</span></span
                >
              </button>
            </p>
            <p class="text-center medium-text-right" *ngIf="isPendingInCart && !showPendingOrder">
              <span class="rs-txt-warning rs-font-pxB">
                <i class="icon-Status-ongoing rs-margin-right1" aria-hidden="true"></i
                >{{ 'mobile.favapp.pending.for' | translate }}{{ pendingFor }}</span
              >
            </p>
            <p class="small-only-text-center rs-padding-bottom1" *ngIf="showPendingOrder">
              <span class="rs-txt-error rs-font-pxB"
                ><i class="icon-Warning-box rs-margin-right1" aria-hidden="true"></i
                >{{ 'mobile.favapp.pending' | translate }}</span
              >
            </p>
            <p *ngIf="showPendingOrder">
              {{ 'mobile.favapp.pending.message' | translate }}
            </p>
          </div>
        </div>
      </div>
      <div id="jsrs-edit-favapp" [hidden]="!editFavApp">
        <div role="group" aria-labelledby="ModalTitle" data-cy="availableFavApps">
          <p id="ModalTitle">{{ 'mobile.favapp.choose' | translate }}</p>
          <div class="rs-flex-row">
            <div
              class="rs-flex-columns small-6 medium-4"
              *ngFor="let favapp of availableFavApps; let i = index"
            >
              <div class="rs-sbox rs-pos-rel">
                <input
                  id="{{ 'sRadio0-' + i }}"
                  type="radio"
                  name="radioSbox"
                  [(ngModel)]="selectedFavapp"
                  [value]="favapp.optionCodeForDescription"
                />
                <label for="{{ 'sRadio0-' + i }}">
                  <span class="rs-sbox-maincontent">
                    <span class="rs-sbox-check-header">
                      <span class="rs-sbox-check"></span>
                      <span class="rs-sbox-check-content text-center">
                        <span class="rs-sbox-title">
                          <img
                            class="rs-mh-s5 rs-maxh-m6 rs-padding1 rs-no-margin rs-pos-tr"
                            alt="{{ favapp.name }}"
                            [src]="favapp.iconLocation"
                          />
                        </span>
                      </span>
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div
            class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
          >
            <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
              <button
                class="rs-btn"
                (click)="changeFavapp()"
                [ngClass]="{ 'rs-btn-waiting': isOrdering }"
                [disabled]="!isFavAppChanged"
              >
                {{ 'mobile.favapp.save' | translate }}
                <div *ngIf="isOrdering" class="rs-btn-waiting-dots"></div>
              </button>
            </div>
            <div class="rs-flex-columns rs-order-m1">
              <p class="small-only-text-center" (click)="toggleEditor()">
                <a
                  href="javascript:void(0)"
                  role="button"
                  class="jsrs-back-favapp"
                  data-tms-event="button-click"
                  attr.data-tms-button-zone="{{ 'mobile.favapp.title' | translate }}"
                  attr.data-tms-button-name="{{ 'mobile.favapp.cancel' | translate }}"
                >
                  {{ 'mobile.favapp.cancel' | translate }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="panel rs-bg-grey1 clearfix"
    *ngIf="selectedProduct?.mobileProductDetails?.activeSubscription?.family === 'Epic'"
  >
    <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
      {{ 'mobile.favapp.unlimitedApps' | translate }}
    </h3>
    <div class="panel rs-bg-grey3 clearfix" aria-live="polite">
      <span
        *ngIf="favAppFlavour === 'epic_beats'"
        [innerHTML]="'mobile.priceplan.epicbeats' | translate"
      ></span>
      <span
        *ngIf="favAppFlavour === 'epic_stories'"
        [innerHTML]="'mobile.priceplan.epicstories' | translate"
      ></span>
      <span
        *ngIf="favAppFlavour === 'epic_videos'"
        [innerHTML]="'mobile.priceplan.epicvideos' | translate"
      ></span>
    </div>
  </div>
</div>
